export default "__VITE_ASSET__DRyG7aRg__"